import createValidator from '../../lib/validator'
import { isEmpty } from '../../lib/validator/helpers'

export default {
  entityInfosSlug (entity = 'customer') {
    return entity === 'customer' ? 'customer_infos' : 'contractor_infos'
  },

  postalCode: (pass, data, custom) => {
    if (isEmpty(data.country_code)) {
      /* FIND MIN/MAX POSTAL CODE LENGTH */
      const pcMinLength = custom.availableCountries
        .reduce((acc, current) => (acc < current.cp_length ? acc : current.cp_length), 10)
      const pcMaxLength = custom.availableCountries
        .reduce((acc, current) => (acc > current.cp_length ? acc : current.cp_length), 0)

      const rule = 'required|' + (pcMinLength === pcMaxLength
        ? 'size:5'
        : 'gte:' + pcMinLength + '|lte:' + pcMaxLength)
      const postalCodeValidator = createValidator({
        data,
        rules: {
          postal_code: rule
        }
      }).validate()

      pass(!postalCodeValidator.fails, postalCodeValidator.errors().list)
    } else {
      const postalCodeValidator = createValidator({
        data,
        rules: {
          postal_code: 'required|size:' + (custom.availableCountries.filter((country) => country.code.toLowerCase() === data.country_code.toLowerCase())[0].cp_length)
        }
      }).validate()

      pass(!postalCodeValidator.fails, postalCodeValidator.errors().list)
    }
  },

  customerFullNameByEntity (entity = 'customer') {
    const entityInfos = this[this.entityInfosSlug(entity)]
    return this.genders[entityInfos.gender] + ' ' + entityInfos.last_name + ' ' + entityInfos.first_name
  },

  addressReformedByEntity (entity = 'customer') {
    return this[this.entityInfosSlug(entity)].address
      .split('\n')
      .filter(lines => lines !== '')
  }
}
